import { graphql } from 'gql';

export const isUniqueVariableGroupGql = graphql(`
    query isUniqueVariableGroup(
        $groupName: String!
        $catalogUniqueId: String!
        $groupId: Int
        $isGlobal: Boolean!
        $methodology: ProjectMethodologyEnum!
    ) {
        isUniqueVariableGroup(
            groupName: $groupName
            groupId: $groupId
            catalogUniqueId: $catalogUniqueId
            isGlobal: $isGlobal
            methodology: $methodology
        ) {
            result
        }
    }
`);

export const createCatalogOtherCostVariableGroupGql = graphql(`
    mutation createCatalogOtherCostVariableGroup($input: CatalogOtherCostVariableGroupCreateInput!) {
        createCatalogOtherCostVariableGroup(input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const updateCatalogOtherCostVariableGroupGql = graphql(`
    mutation updateCatalogOtherCostVariableGroup($input: CatalogOtherCostVariableGroupUpdateInput!) {
        updateCatalogOtherCostVariableGroup(input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const removeCatalogOtherCostVariableGroupGql = graphql(`
    mutation removeCatalogOtherCostVariableGroup($groupId: Int!) {
        removeCatalogOtherCostVariableGroup(groupId: $groupId) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const catalogOtherCostVariableGroupListGql = graphql(`
    query catalogOtherCostVariableGroupList(
        $catalogUniqueId: String!
        $globalOnly: Boolean!
        $methodology: ProjectMethodologyEnum!
        $order: [CatalogOtherCostVariableGroupItemDataSortInput!]
    ) {
        catalogOtherCostVariableGroupList(
            catalogUniqueId: $catalogUniqueId
            globalOnly: $globalOnly
            methodology: $methodology
            order: $order
        ) {
            items {
                id
                name
                variableCount
                methodology
            }
        }
    }
`);
